import { useEffect } from "react";
import { useLocation, Navigate, Route, Routes } from "react-router-dom";
import { useAuthStore } from "../features/auth/store";
import AppShell from "../widgets/AppShell/AppShell";
import FeedPage from "../pages/home/HomePage";
import ExplorePage from "../pages/explore/ExplorePage";
import CreateHubPage from "../pages/create/CreateHubPage";
import MessagesPage from "../pages/messages/MessagesPage";
import OrdersPage from "../pages/orders/OrdersPage";
import GrabOrdersPage from "../pages/orders/GrabOrdersPage";
import ProfilePage from "../pages/profile/ProfilePage";
import NotificationsPage from "../pages/notifications/NotificationsPage";
import PostDetailPage from "../pages/post-detail/PostDetailPage";
import PublicProfilePage from "../pages/profile/PublicProfilePage";
import SettingsPage from "../pages/settings/SettingsPage";
import AccountSecurityPage from "../pages/settings/AccountSecurityPage";
import ProviderApplicationPage from "../pages/settings/ProviderApplicationPage";
import OrderDetailPage from "../pages/orders/OrderDetailPage";
import PaymentReturnPage from "../pages/orders/PaymentReturnPage";
import { getProtectedRoute } from "./routePolicy";

function RequireAuth({ children }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  const redirect = getProtectedRoute({ isAuthenticated, pathname: location.pathname });
  if (redirect) {
    return <Navigate to={redirect.pathname} replace state={redirect.state} />;
  }

  return children;
}

export function MainApp() {
  const location = useLocation();
  const backgroundLocation = location.state?.backgroundLocation;

  useEffect(() => {
    if (backgroundLocation) return;
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
  }, [backgroundLocation, location.key]);

  return (
    <AppShell>
      <Routes location={backgroundLocation || location}>
        <Route path="/" element={<FeedPage />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/posts/:postId" element={<PostDetailPage />} />
        <Route path="/users/:userId" element={<PublicProfilePage />} />
        <Route path="/create" element={<RequireAuth><CreateHubPage /></RequireAuth>} />
        <Route path="/messages/*" element={<RequireAuth><MessagesPage /></RequireAuth>} />
        <Route path="/grab-orders" element={<RequireAuth><GrabOrdersPage /></RequireAuth>} />
        <Route path="/orders" element={<RequireAuth><OrdersPage /></RequireAuth>} />
        <Route path="/orders/receive" element={<Navigate to="/orders?view=received" replace />} />
        <Route path="/orders/send" element={<Navigate to="/orders?view=sent" replace />} />
        <Route path="/orders/new" element={<Navigate to="/create?type=order" replace />} />
        <Route path="/orders/:orderId" element={<RequireAuth><OrderDetailPage /></RequireAuth>} />
        <Route path="/payment/return" element={<RequireAuth><PaymentReturnPage /></RequireAuth>} />
        <Route path="/payment/return/" element={<RequireAuth><PaymentReturnPage /></RequireAuth>} />
        <Route path="/profile" element={<RequireAuth><ProfilePage /></RequireAuth>} />
        <Route path="/notifications" element={<RequireAuth><NotificationsPage /></RequireAuth>} />
        <Route path="/settings/profile" element={<RequireAuth><SettingsPage /></RequireAuth>} />
        <Route path="/settings/security" element={<RequireAuth><AccountSecurityPage /></RequireAuth>} />
        <Route path="/settings/provider" element={<RequireAuth><ProviderApplicationPage /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {backgroundLocation ? (
        <Routes location={location}>
          <Route path="/posts/:postId" element={<PostDetailPage modal />} />
        </Routes>
      ) : null}
    </AppShell>
  );
}
